import React, { PureComponent } from 'react';
import { Radar, RadarChart, PolarGrid, Legend, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer } from 'recharts';

const data = [
  {
    subject: 'Peso Promedio',
    Malabrigo: 120,
    Chimbote: 110,
    Vegueta: 150,
    Callao: 40,
    fullMark: 300,
  },
  {
    subject: 'Tiempo por planta',
    Malabrigo: 98,
    Chimbote: 130,
    Vegueta: 200,
    Callao: 10,
    fullMark: 300,
  },
  {
    subject: 'Cumplimiento personas',
    Malabrigo: 86,
    Chimbote: 130,
    Vegueta: 14,
    Callao: 250,
    fullMark: 300,
  },
  {
    subject: 'Cumplimiento vehicular',
    Malabrigo: 99,
    Chimbote: 100,
    Vegueta: 140,
    Callao: 300,
    fullMark: 300,
  },
  {
    subject: 'Vehiculos pesado',
    Malabrigo: 85,
    Chimbote: 90,
    Vegueta: 300,
    Callao: 45,
    fullMark: 300,
  },
];

export default class Ejemplo extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      ubicacionesSeleccionadas: [], 
    };
  }
  manejarCambioUbicacion = (event) => {
    const { value, checked } = event.target;
    this.setState((prevState) => {
      const ubicacionesSeleccionadas = checked
        ? [...prevState.ubicacionesSeleccionadas, value]
        : prevState.ubicacionesSeleccionadas.filter((ubicacion) => ubicacion !== value);
      return { ubicacionesSeleccionadas };
    });
  };

  obtenerDatosUbicacionesSeleccionadas() {
    const { ubicacionesSeleccionadas } = this.state;
    return data.map((item) => {
      const itemFiltrado = {};
      itemFiltrado.subject = item.subject;
      ubicacionesSeleccionadas.forEach((ubicacion) => {
        itemFiltrado[ubicacion] = item[ubicacion];
      });
      return itemFiltrado;
    });
  }

  obtenerColorUbicacion(ubicacion) {
    const colores = {
      Malabrigo: '#43B02A',
      Chimbote: '#CA2D00',
      Vegueta: '#007696',
      Callao: '#FFC700',
    };
    return colores[ubicacion] || '#000'; 
  }

  obtenerInfoUbicaciones() {
    const { ubicacionesSeleccionadas } = this.state;
    return ubicacionesSeleccionadas.map((ubicacion) => {
      const datosVehiculos = data[4][ubicacion]; 
      const pesoPromedio = data[0][ubicacion]; 
      const porcentajeCumplimiento = (data[3][ubicacion] / 300) * 100; 
      const colorUbicacion = this.obtenerColorUbicacion(ubicacion); 

      return (
        <div key={ubicacion}>
          <h4 className='mt-3 text-[16px] font-itcmedium' style={{ color: colorUbicacion }}>
            {ubicacion}
          </h4>
          <div className='flex space-x-6'>
            <div>
              <p className='text-[22px] text-[#2F2F3B] font-itcmedium'>{datosVehiculos}</p>
              <p className='font-itcmedium text-[12px] text-[#52526CCC]'>Vehículos pesados</p>
            </div>
            <div>
              <p className='text-[22px] text-[#2F2F3B] font-itcmedium'>{pesoPromedio} kg</p>
              <p className='font-itcmedium text-[12px] text-[#52526CCC]'>Peso promedio</p>
            </div>
            <div>
              <p className='text-[22px] text-[#2F2F3B] font-itcmedium'>{porcentajeCumplimiento.toFixed(0)}%</p>
              <p className='font-itcmedium text-[12px] text-[#52526CCC]'>Cumplimiento</p>
            </div>
          </div>
        </div>
      );
    });
  }

  render() {
    const { ubicacionesSeleccionadas } = this.state;
    const datosFiltrados = this.obtenerDatosUbicacionesSeleccionadas();

    return (
      <div className="justify-center p-6 bg-white shadow-[0px_5px_20px_rgba(0,0,0,0.3)] rounded-[16px] mb-10">
        <div className="flex items-center ">
          <p className="text-[20px] font-itcmedium text-[#007696] ">Comparativo por Plantas</p>
          <button className="sm:px-[35px]  px-[35px] ml-[17rem] xl:ml-[28rem] 2xl:ml-[48rem] h-[46px] text-[14px] text-center bg-white border-2 text-[#52526C] rounded-[8px] font-itcmedium border-[#5CBDEB]">
            Filtrar por tiempo
          </button>
        </div>

        <div className='flex mt-6 space-x-6 2xl:space-x-36 justify-center'>
          <div>
            <ResponsiveContainer width={400} height={300}>
              <RadarChart cx="50%" cy="50%" outerRadius="70%" data={datosFiltrados}>
                <PolarGrid />
                <PolarAngleAxis dataKey="subject" tick={{ fontSize: 12, fill: '#52526C' }} />
                <PolarAngleAxis dataKey="subject" />
                <PolarRadiusAxis angle={30} domain={[0, 300]} />
                {ubicacionesSeleccionadas.includes('Malabrigo') && (
                  <Radar name="Malabrigo" dataKey="Malabrigo" stroke="#43B02A" fill="#43B02A" fillOpacity={0.6} />
                )}
                {ubicacionesSeleccionadas.includes('Chimbote') && (
                  <Radar name="Chimbote" dataKey="Chimbote" stroke="#CA2D00" fill="#CA2D00" fillOpacity={0.6} />
                )}
                {ubicacionesSeleccionadas.includes('Vegueta') && (
                  <Radar name="Vegueta" dataKey="Vegueta" stroke="#007696" fill="#007696" fillOpacity={0.6} />
                )}
                {ubicacionesSeleccionadas.includes('Callao') && (
                  <Radar name="Callao" dataKey="Callao" stroke="#FFC700" fill="#FFC700" fillOpacity={0.6} />
                )}
                
              </RadarChart>
            </ResponsiveContainer>

            <div className='space-x-4 text-[16px] font-itcmedium'>
              <label>
                <input
                  type="checkbox" 
                  value="Malabrigo"
                  checked={ubicacionesSeleccionadas.includes('Malabrigo')}
                  onChange={this.manejarCambioUbicacion}
                  className="mr-1"
                />
                Malabrigo
              </label>
              <label>
                <input
                  type="checkbox"
                  value="Chimbote"
                  checked={ubicacionesSeleccionadas.includes('Chimbote')}
                  onChange={this.manejarCambioUbicacion}
                  className="mr-1"
                />
                Chimbote
              </label>
              <label>
                <input
                  type="checkbox"
                  value="Vegueta"
                  checked={ubicacionesSeleccionadas.includes('Vegueta')}
                  onChange={this.manejarCambioUbicacion}
                  className="mr-1"
                />
                Vegueta
              </label>
              <label>
                <input
                  type="checkbox"
                  value="Callao"
                  checked={ubicacionesSeleccionadas.includes('Callao')}
                  onChange={this.manejarCambioUbicacion}
                  className="mr-1"
                />
                Callao
              </label>
            </div>
          </div>

          <div className=''>
            {this.obtenerInfoUbicaciones()}
          </div>
        </div>  
      </div>
    );
  }
}
